/** Slide duration when minimizing the call view (ms). */
export const CALL_MINIMIZE_ANIMATION_MS = 900;

/** Slide duration when restoring to fullscreen (ms). */
export const CALL_RESTORE_ANIMATION_MS = 600;

/** Element id on the portaled minimized call dock root (for height measurement). */
export const MINIMIZED_CALL_BANNER_DOCK_ELEMENT_ID = 'minimized-call-banner-dock';

/** CSS custom property for main-content bottom inset while the dock is visible. */
export const MINIMIZED_CALL_DOCK_RESERVE_CSS_VAR =
  '--minimized-call-dock-reserve-height';

/** Fallback reserve height when the dock has not measured yet (px). */
export const MINIMIZED_CALL_DOCK_RESERVE_FALLBACK_PX = 120;

/** Document attribute set while the minimized call dock is visible. */
export const MINIMIZED_CALL_DOCK_ACTIVE_ATTR = 'data-minimized-call-dock';

/**
 * Fixed z-index for the minimized call dock.
 * Member-page stack (low to high): JIT 900, dock 950, SpeedDial backdrop
 * (999 / 1100 when dock visible), SpeedDial (1000 / 1200 when dock visible),
 * modal leave confirmation 1300.
 */
export const MINIMIZED_CALL_DOCK_Z_INDEX = 950;

/**
 * Resolve the minimized call dock z-index.
 * Kept as a function so call sites and tests share one source of truth.
 *
 * @returns Dock z-index below SpeedDial and modal layers.
 */
export function getMinimizedCallDockZIndex(): number {
  return MINIMIZED_CALL_DOCK_Z_INDEX;
}

const CALL_MINIMIZE_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

/**
 * CSS transition for the fullscreen dialog paper, with direction-specific duration.
 *
 * @param minimized - When true, use the slower minimize timing for the next transition.
 * @returns CSS transition value for the dialog paper.
 */
export function getCallMinimizePaperTransition(minimized: boolean): string {
  const durationMs = minimized
    ? CALL_MINIMIZE_ANIMATION_MS
    : CALL_RESTORE_ANIMATION_MS;
  const durationSeconds = `${durationMs / 1000}s`;

  return `transform ${durationSeconds} ${CALL_MINIMIZE_EASING}, height ${durationSeconds} ${CALL_MINIMIZE_EASING}, border-radius ${durationSeconds} ease`;
}
